require('angular').module('wowApp.common')
    .service('DeploymentSwitchService', [require('./deployment-switch.service')]);



// WEBPACK FOOTER //
// ./src/common/deploymentswitch/index.js